var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 21H18.3M12 12.6923C13.5464 12.6923 14.8 11.4525 14.8 9.92308C14.8 8.3937 13.5464 7.15385 12 7.15385C10.4536 7.15385 9.2 8.3937 9.2 9.92308C9.2 11.4525 10.4536 12.6923 12 12.6923ZM19 9.92308C19 16.1538 12 21 12 21C12 21 5 16.1538 5 9.92308C5 8.08694 5.7375 6.32605 7.05025 5.02772C8.36301 3.72939 10.1435 3 12 3C13.8565 3 15.637 3.72939 16.9498 5.02772C18.2625 6.32605 19 8.08694 19 9.92308Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.2d01f82b6a8a18ebcd2ae1a5445713ac.svg";
export { ForwardRef as ReactComponent };